import type { NetworkProvider } from '@dynamic-labs-sdk/client';

import type { EvmNetworkProvider } from '../EvmNetworkProvider';

/**
 * Type guard function to check if a network provider is an EVM network provider.
 *
 * @param networkProvider - The network provider to check.
 * @returns True if the network provider is an EVM network provider, false otherwise.
  * @not-instrumented
 */
export const isEvmNetworkProvider = (
  networkProvider: NetworkProvider
): networkProvider is EvmNetworkProvider => networkProvider.chain === 'EVM';
